import {Workbox} from "workbox-window";

const ServiceWorker = function(global) {
    
    const log = global.log.getLogger("f_mtac.application.serviceworker");
    log.setLevel(log.levels.INFO);

    const supported_service_worker = "serviceWorker" in navigator ? true : false;
    const supported_service_worker_register = supported_service_worker && "register" in navigator.serviceWorker ? true : false;

    let f_mtac_version;

    // mtac_version is the version of the package f_mtac.min.js
    Object.defineProperty(this, "mtac_version", {
        set: () => {},
        get: () => f_mtac_version
    });

    this.register = async () => {
        if (!supported_service_worker_register) {
            return;
        }
        log.debug("ServiceWorker.register IN");
        let first_time;
        try {
            var registration = await navigator.serviceWorker.register("/mtac/f_mtac_worker.min.js", {scope: "/"});

            /* For logs */
            if (registration.installing) {
                log.debug("ServiceWorker installing");
            } else if (registration.waiting) {
                log.debug("ServiceWorker installed");
            } else if (registration.active) {
                log.debug("ServiceWorker active");
            }

            // At start, f_mtac_version is supposed to be identical to f_mtac_worker version (version of package f_mtac_worker.min.js)
            f_mtac_version = this.get_active_version();
            log.debug(`ServiceWorker.register starting_version=${f_mtac_version}`);

            // detect Service Worker update available and wait for it to become installed
            registration.addEventListener("updatefound", () => {
                log.info("ServiceWorker.on updatefound!");
                if (registration.installing) {
                    log.debug("ServiceWorker update is installing");

                    // wait until the new Service worker is actually installed (ready to take over)
                    registration.installing.addEventListener("statechange", () => {
                        log.debug("ServiceWorker.on statechange!");

                        // for logs
                        if (registration.installing) {
                            log.debug("ServiceWorker update installing");
                        } else if (registration.waiting) {
                            log.debug("ServiceWorker update installed");
                            if (navigator.serviceWorker.controller) {
                                log.debug("ServiceWorker.waiting New version of the app is available.");
                            } else {
                                // otherwise it's the first install, nothing to do
                                log.debug("Service Worker initialized for the first time");
                                first_time = true;
                            }
                        } else if (registration.active) {
                            log.debug("ServiceWorker update active");
                        }
                    });
                }
            });

            // detect controller change and refresh the page
            navigator.serviceWorker.addEventListener("controllerchange", async (event) => {
                //import ConfirmationArea from "../ui/ConfirmationArea.js";
                // if ConfirmationArea can not be imported from the top level because global.log is not ready yet
                // -> import it dynamically
                log.debug("ServiceWorker.controllerchange event", event);
                log.debug("ServiceWorker.controllerchange controller", navigator.serviceWorker.controller);
                if (registration.installing) {
                    log.debug("ServiceWorker controller registration installing");
                } else if (registration.waiting) {
                    log.debug("ServiceWworker controller registration installed");
                } else if (registration.active) {
                    log.debug("ServiceWorker controller registration active first_time = ", {first_time});

                    // get confirmation if not first installation
                    if (first_time !== true) {
                        let {default: ConfirmationArea} = await import("../ui/ConfirmationArea.js");

                        // here, f_mtac_worker version is the one of the new f_mtac_worker.min.js installed
                        // mtac_version, version of f_mtac.min.js didn't change
                        const version = await this.get_active_version();

                        let confirmation = await ConfirmationArea.interact({
                            title: global.internationalization.text("startup.Application-update"),
                            tip1: global.internationalization.text("startup.A-new-version-is-available-validate-to-install", {version})
                        });
                        if (confirmation) {
                            window.location.reload();
                        }
                    }
                    // get confirmation next times
                    first_time = false;
                }
            });

            log.debug("ServiceWorker registration = ", {registration});
        } catch (error) {
            log.error("ServiceWorker failed to register:", error.message);
            return false;
        }
        log.info("ServiceWorker registered in scope:", registration.scope);
    };


    /**
     * @brief interrogate the service worker to get the active versions
     * @returns the version of f_mtac_worker.min.js. 
     * It can be different from actual app running (package f_mtac.min.js).
     */
    this.get_active_version = async () => {
        const wb = new Workbox("/mtac/f_mtac_worker.min.js");
        wb.register();
        let version = await wb.messageSW({type: "GET_VERSION"});
        log.debug(`ServiceWorker.get_version = ${version}`);
        return version;
    };
};


export default ServiceWorker;
